<template>
  <router-link
    :to="`/properties/view/${property.id}`"
    v-if="property.photos.length"
  >
    <div class="property-box-style mb-4">
      <div class="image">
        <div class="image-container">
          <img
            :src="
              `${baseImageUrl}/storage/${
                property.photos.length ? property.photos[0].image : ''
              }`
            "
            alt="fp1.jpg"
          />
        </div>
        <div class="overlay">
          <div class="tags">
            <ul>
              <li>{{ LISTING_TYPES[property.listing_type] }}</li>
              <li v-if="property.is_advertised">Featured</li>
            </ul>
          </div>
          <div class="price">
            &euro;{{ property.price }} <small class="font-normal"> monthly</small>
            <h4 class="font-normal">{{ property.city.name }}</h4>
          </div>
        </div>
      </div>
    </div>
  </router-link>
</template>

<script>
import { LISTING_TYPES } from "@/constants";
export default {
  props: ["property"],
  data: function() {
    return {
      LISTING_TYPES,
      baseImageUrl: process.env.VUE_APP_API_URL,
    };
  },
};
</script>

<style lang="scss" scoped>
.property-box-style {
  .image {
    @apply relative rounded-lg overflow-hidden;

    .overlay {
      @apply absolute top-0 w-full h-full bg-black bg-opacity-50 text-white;

      .tags {
        @apply absolute w-full top-0 px-4 py-4;

        ul li {
          @apply inline-block bg-black px-3 py-1 text-xs rounded-md mr-2;

          &:last-child {
            @apply text-black bg-primary-color;
          }
        }
      }
      .price {
        @apply absolute w-full bottom-0 px-6 py-3 text-2xl font-bold;
      }
    }
  }

  ul li {
    @apply inline-block pr-8;
  }
}
</style>
